/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { createContext } from "react";

/**
 * @typedef {object} DynamicFieldContext
 * @property {number} position
 */

/**
 * @type {DynamicFieldContext}
 */
const defaultContext = {};

export const DynamicFieldContext = createContext(defaultContext);
